
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/editorSearch/EditorSearchPanel/EditorSearchPanel.scss.css.virtualfile';
        module.exports = {"overlay":"_overlay_7yzc7_7","container":"_container_7yzc7_15"};